export default __webpack_public_path__ + "static/media/ic_arbitrum_hover_16.472c51ea.svg";